export default __webpack_public_path__ + "navigation-examples-basic-v1-1200-5fbdcdb745935a227b071d859bc95334.png";